import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { AlertTriangle, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Admin = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!confirm) {
      setError("Please tick the confirmation box.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/site/kill`, { password });
      // Force reload so the kill-state check picks it up everywhere
      window.location.replace("/");
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to shut down");
      setLoading(false);
    }
  };

  return (
    <div className="page-narrow" data-testid="admin-page">
      <div className="status-card">
        <Lock size={36} className="bad" />
        <h2>SITE KILL SWITCH</h2>
        <p className="warn-line">
          <AlertTriangle size={16} />
          <span>This action is <strong>permanent and irreversible</strong>. Once confirmed, the entire site will be taken offline for everyone — including you. There is no revive flow.</span>
        </p>

        <form onSubmit={submit} className="kill-form">
          <label className="field-label" htmlFor="kill-pw">PASSWORD</label>
          <input
            id="kill-pw"
            type="password"
            className="text-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
            data-testid="admin-password-input"
            required
          />

          <label className="check-row">
            <input
              type="checkbox"
              checked={confirm}
              onChange={(e) => setConfirm(e.target.checked)}
              data-testid="admin-confirm-checkbox"
            />
            <span>I understand this will permanently shut the site down.</span>
          </label>

          {error && <p className="error-msg" data-testid="admin-error">{error}</p>}

          <button
            type="submit"
            className="btn btn-danger btn-lg full"
            disabled={loading}
            data-testid="admin-kill-btn"
          >
            {loading ? "SHUTTING DOWN…" : "SHUT THE SITE DOWN"}
          </button>
        </form>

        <button
          type="button"
          className="back-link"
          onClick={() => navigate("/")}
          data-testid="admin-cancel"
        >
          ← CANCEL
        </button>
      </div>
    </div>
  );
};

export default Admin;
